import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {Router} from "@angular/router";
import {FormatService} from "@city-tax/shared";

@Component({
  selector: 'city-tax-landing-individual',
  templateUrl: './landing-individual.component.html',
  styleUrls: ['./landing-individual.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingIndividualComponent implements OnInit {

  @Input() public config$: any;
  @Output() public lookupEvent = new EventEmitter<void>();

  public hasIndividual$ = new BehaviorSubject(false);
  public file$ = new BehaviorSubject(false);
  public estimateLookups$ = new BehaviorSubject(false);
  public payments$ = new BehaviorSubject(false);
  public processingFee = '3.0%';
  public feeMinimum = '$1.95';

  public isClosed$ = new BehaviorSubject(true);
  public openDate: any = null;

  constructor(
    private cd: ChangeDetectorRef,
    private formatService: FormatService,
    private router: Router
  ) {

  }

  ngOnInit(): void {

    this.config$?.subscribe((config: any) => {
      if (config) {
        const components = config?.components || {};
        const individual = components?.individual || {};

        const processingFee = config.processingFee || 0.03;
        const feeMinimum = config.feeMinimum || 1.95;

        this.processingFee = (processingFee * 100).toFixed(1) + '%';
        this.feeMinimum = `$${feeMinimum.toFixed(2)}`;

        const hasIndividual = individual.payments || individual.estimates || individual.uploadToFile || individual.fillToFile || individual.estimateLookups;
        this.hasIndividual$.next(hasIndividual);
        const file = individual.uploadToFile || individual.fillToFile;
        this.file$.next(file);
        const estimateLookups = individual.estimateLookups;
        this.estimateLookups$.next(estimateLookups);
        const payments = individual.payments || individual.estimates;
        this.payments$.next(payments);
        const isClosed = this.isClosed(individual.eFileCloseDate);
        this.isClosed$.next(isClosed);
        this.openDate = individual.eFileOpenDate;
        this.cd.detectChanges();
      }
    });
  }

  lookup(): void {
    this.lookupEvent.emit();
  }

  isClosed(eFileCloseDate: any) {
    const nowDate = new Date();
    if (!eFileCloseDate) return false;
    const closeDate = new Date(eFileCloseDate);
    return nowDate > closeDate;
  }

  onRedirect(path: string): void {
    this.router.navigate(['/auth/individual'], {queryParams: {redirectPath: path}});
  }

}
